import React, { useState, useEffect } from 'react';
import './CustomOdometer.css';
const CustomOdometer = ({ value, type }) => {
  const [currentValue, setCurrentValue] = useState(0);
  useEffect(() => {
    if (value !== currentValue) {
      const step = value > currentValue ? 1 : -1; 
      const interval = setInterval(() => {
        setCurrentValue((prev) => {
          const nextValue = prev + step;
          if ((step > 0 && nextValue >= value) || (step < 0 && nextValue <= value)) {
            clearInterval(interval);
            return value;
          }
          return nextValue;
        });
      }, 50); 
      return () => clearInterval(interval);
    }
  }, [value, currentValue]);
  const formattedValue = currentValue.toString().padStart(4, '0');
  return (
    <div className={`custom-odometer-container ${type === 'yesterdays' ? 'yesterdays-odo' : ''}`}>
      {formattedValue.split('').map((digit, index) => (
        <div key={index} className="custom-odometer-digit">
          {digit}
        </div>
      ))}
    </div>
  );
};
export default CustomOdometer;
